import React, { PureComponent } from 'react';
import Snackbar from '@mui/material/Snackbar';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { setSnackbar, resetSnackbar } from '../../actions';
import '../../index.css';

class NotificationBar extends PureComponent {

  handleSnackbarClose = () => {
    this.props.resetSnackbar();
  }

  render() {
    return (
      <Snackbar
        ContentProps={{
          classes: {
            root: this.props.snackbar.severity
          }
        }}
        anchorOrigin={{vertical: this.props.snackbar.vertical, horizontal: this.props.snackbar.horizontal}}
        open={this.props.snackbar.open}
        onClose={this.handleSnackbarClose}
        message={this.props.snackbar.message}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    snackbar: state.general.snackbar,
  };
};

export default connect(mapStateToProps, {
  setSnackbar,
  resetSnackbar
})(withRouter(NotificationBar));
